<template>
  <div style="background-color: white; border-radius: 5px; margin-bottom: 5px">
    <p class="P_XT" style="">审批详情</p>
    <el-steps :space="400" :active="num_zt" finish-status="success">
      <el-step
        v-for="(item, index) in ApproveList.approvaList"
        :key="index"
        :status="item.approvalStatus == '5' ? 'error' : ''"
        :title="item.approverName"
        :description="
          item.approvalStatus == 1
            ? '(发起人) ' + (item.approvalDate != null ? item.approvalDate : '')
            : item.approvalStatus == 2
            ? '(待审批) ' + (item.approvalDate != null ? item.approvalDate : '')
            : item.approvalStatus == 3
            ? '(未审批) ' + (item.approvalDate != null ? item.approvalDate : '')
            : item.approvalStatus == 4
            ? '(已审批) ' + (item.approvalDate != null ? item.approvalDate : '')
            : item.approvalStatus == 5
            ? '(已驳回) ' + (item.approvalDate != null ? item.approvalDate : '')
            : ''
        "
      ></el-step>
    </el-steps>
    <!-- <div v-if="request_list.isadmin && SP_IF">
        <el-alert title="请在下方补充信息" style="margin-top: 20px" type="warning"></el-alert>
        <br />
        <div class="demo-input-suffix">
          <span style="color: red">*</span>
          HCP ID
          <el-input v-model="approval_request_Put_Material_list.data.HCPID" style="width: 250px" placeholder="请输入"></el-input>
        </div>
      </div> -->
    <el-alert
      v-if="description_text"
      title="驳回原因"
      type="error"
      style="margin-top: 20px"
      :description="description_text"
      :closable="false"
      show-icon
    ></el-alert>
    <div v-if="SP_IF == 'SP'" style="margin-top: 20px; margin-bottom: 20px">
      <el-button type="success" @click="submit_approvals(true)">同 意</el-button>
      <el-button
        type="danger"
        @click="
          dialogVisible = true
          titles_dia = '驳回原因'
        "
      >
        驳 回
      </el-button>
    </div>
    <div v-if="SP_IF != 'SP' && CH_IF && ApproveList.approvalMaster.finalStatus != 3" style="margin-top: 20px; margin-bottom: 20px">
      <el-button type="danger" @click="ch_approvals">撤回审批</el-button>
    </div>
    <!-- <el-divider></el-divider> -->
    <el-dialog :title="titles_dia" :visible.sync="dialogVisible" width="30%">
      <el-input type="textarea" v-model="approval_obj.reasonMessage"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" v-preventReClick="3000" @click="turn_approvals()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { isExternal } from '../../util/validate'

export default {
  name: 'Approve',
  data() {
    return {
      titles_dia: '提示',
      CH_IF: true,
      dialogVisible: false,
      approval_obj: {
        approvedId: '',
        isApproved: '',
        reasonMessage: '',
      },
      request_list: [],
      description_text: '',
      num_zt: 0,
    }
  },
  props: ['ApproveList', 'SP_IF'],
  //   props: {
  //     ApproveList: {
  //       type: Object,
  //       default: {},
  //     },
  //   },
  computed: {},
  created() {
    this.ApproveListFn()
  },
  //   watch: {
  //     ApproveList() {
  //       this.ApproveListFn()
  //     },
  //   },
  methods: {
    turn_approvals() {
      this.approval_obj.isApproved = false
      this.$emit('approve_submit', this.approval_obj)
      this.dialogVisible = false
    },
    ch_approvals() {
      this.approval_obj.isApproved = true
      this.approval_obj.CH_IF = true
      this.$confirm('确认撤回？')
        .then((_) => {
          this.$emit('approve_submit', this.approval_obj)
        })
        .catch((_) => {})
    },
    submit_approvals() {
      this.approval_obj.isApproved = true
      this.$confirm('确认同意？')
        .then((_) => {
          this.$emit('approve_submit', this.approval_obj)
        })
        .catch((_) => {})
    },
    ApproveListFn() {
      let num_zt = 1
      let request_list = this.ApproveList.approvaList
      this.approval_obj.approvedId = this.ApproveList.approvaList[0].approvalId
      for (var i in request_list) {
        if (request_list[i].approvalStatus == 4) {
          num_zt++
          this.CH_IF = false
        }
        if (request_list[i].approvalStatus == 5) {
          this.description_text = request_list[i].comments
          this.CH_IF = false
        }
      }
      this.num_zt = num_zt
      console.log(num_zt)
    },
    linkProps(to) {
      if (this.isExternal) {
        return {
          href: to,
          target: '_blank',
          style: 'color:#fff;',
        }
      }
      return {
        to: to,
      }
    },
  },
}
</script>
